import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import api from '../services/api';
import './Layout.css';

const Layout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [tradingMode, setTradingMode] = useState('testnet');
  const [modeLoading, setModeLoading] = useState(false);

  useEffect(() => {
    fetchTradingMode();
  }, []);

  const fetchTradingMode = async () => {
    try {
      const res = await api.get('/trading/trading-mode');
      setTradingMode(res.data.mode);
    } catch (e) {
      // default testnet
    }
  };

  const toggleMode = async () => {
    const newMode = tradingMode === 'testnet' ? 'mainnet' : 'testnet';
    const label = newMode === 'mainnet' ? '本番' : 'テスト';
    let message = `${label}モードに切り替えますか？`;
    if (newMode === 'testnet') {
      message += '\n\n⚠ 注意: テストモードに切り替えると、本番モードでの自動エントリーが停止します。';
    }
    if (!window.confirm(message)) return;

    setModeLoading(true);
    try {
      const res = await api.post('/trading/trading-mode', { mode: newMode });
      window.location.reload();
    } catch (error) {
      toast.error(error.response?.data?.message || 'モード切替に失敗しました');
      setModeLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <h1 className="logo">
            <span className="logo-icon">₿</span>
            AutoTrader
          </h1>
        </div>

        <nav className="sidebar-nav">
          <NavLink to="/dashboard" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <span className="nav-icon">📊</span>
            ダッシュボード
          </NavLink>
          <NavLink to="/trade-history" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <span className="nav-icon">📜</span>
            損益履歴
          </NavLink>
          <NavLink to="/asset-history" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <span className="nav-icon">💰</span>
            資産履歴
          </NavLink>
          <NavLink to="/funding-rate-history" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <span className="nav-icon">📈</span>
            FRレート推移
          </NavLink>
          <NavLink to="/currencies" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <span className="nav-icon">🪙</span>
            通貨設定
          </NavLink>
          <NavLink to="/account" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <span className="nav-icon">👤</span>
            アカウント
          </NavLink>
          <div
            className={`nav-item mode-toggle ${tradingMode}`}
            onClick={!modeLoading ? toggleMode : undefined}
            style={{ cursor: 'pointer' }}
          >
            <span className="nav-icon">{tradingMode === 'testnet' ? '🧪' : '🔴'}</span>
            {modeLoading ? '切替中...' : tradingMode === 'testnet' ? 'テストモード' : '本番モード'}
          </div>
        </nav>
        
        {user?.role === 'admin' && (
          <div className="sidebar-admin">
            <NavLink to="/admin" className="nav-item admin-link">
              <span className="nav-icon">⚙️</span>
              管理画面
            </NavLink>
          </div>
        )}
        
        <div className="sidebar-footer">
          <div className="user-info">
            <span className="user-name">{user?.username}</span>
            <span className="user-email">{user?.email}</span>
          </div>
          <button onClick={handleLogout} className="logout-btn">
            ログアウト
          </button>
        </div>
      </aside>
      
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
